export default {
  apply: 'Apply',
  clear: 'Clear',
  search_results: 'Search Results',
  check_all: 'Check all',
  uncheck_all: 'Uncheck all'
};